// ************ ==== >>>> Page <<<< ==== ************//
import Login from "../pages/website/Login";
import Forgotpassword from "../pages/website/Forgotpassword.jsx";
import Resetpassword from "../pages/website/Resetpassword.jsx";
import Dashboardnavbar from "../layout/Dashboardnavbar.jsx";

// ************ ==== >>>> Components <<<< ==== ************//
import Userdetailsmain from "../components/UserDetails/Userdetailsmain.jsx";
import UserDetails from "../components/UserDetails/UserDetails.jsx";

// ************ ==== >>>> HO Supervisor Dashboard <<<< ==== ************//
import HOSupervisorManagementDashboard from "../pages/hodashboard/HOsDashboard.jsx";

// ************ ==== >>>> Site Manager Dashboard <<<< ==== ************//
import SiteManagementDashboard from "../pages/sitedashboard/SiteDashboard.jsx";

// ************ ==== >>>> Admin Dashboard <<<< ==== ************//
import AdminDashboardd from "../pages/admindashboard/AdminDashboard";
import EmployeeDashboard from "../pages/employeeportal/EmployeeDashboard.jsx";
import {
  CompletePage,
  PersonaldetailsProfile,
} from "../components/PersonalDetailsEdit/PersonaldetailsProfile.jsx";

import SiteManagement from "../components/SiteManagement/SiteManagement.jsx";
import { ViewTicket } from "../components/TicketsManagement/TicketsTables.jsx";

import {
  ProjectAllDetails,
  SiteProjectBillDetails,
} from "../components/SiteManagement/SiteProjectManagement.jsx";

// ************ ==== >>>> Site Dashboard <<<< ==== ************//

import { LetterTracking } from "../pages/sitedashboard/Main/LetterTracking.jsx";
// import ExpenseTracking from "../pages/sitedashboard/Main/ExpenseTracking.jsx";
import Wfm from "../components/Wfm/Wfm.jsx";
import { SiteProjectTable } from "../components/SiteManagement/SiteTables.jsx";
import { Detailspage } from "../components/SiteManagement/SiteTables.jsx";
import {
  Invoiceformate,
  PrintBOQformat,
} from "../components/SiteManagement/AdminSiteManagement/Invoiceformate.jsx";
import CertficateAccess from "../components/SiteManagement/CertificateAccess.jsx";
import VehicleLogBook from "../components/SiteManagement/AdminSiteManagement/VehicleLog.jsx";
import OfficeManagement from "../components/OfficeRent/OfficeManagement.jsx";
// import InvoiceTable, { ProfessionalStaff } from "../components/SiteManagement/AdminSiteManagement/ConsultantInvoicetable.jsx";
import {
  ConsultancyDeduction,
  ConsultancyInvoice,
  PrintPayment,
} from "../components/SiteManagement/AdminSiteManagement/ConsultancyInvoice.jsx";

import Boqinvoices from "../pages/sitedashboard/Main/Boqinvoices.jsx";
import SIteUserDetails from "../components/SiteManagement/AdminSiteManagement/UserDetails.jsx";
import BulkAttendanceUpload from "../pages/sitedashboard/Main/Attendance.jsx";
import ManagePayroll from "../components/PayrollManagement/ManagePayroll.jsx";
import Expenses from "../components/ImprestManagement/ExpenseTracking.jsx";
import {
  ImprestRequest,
  HORequestsManagementTab,
  AdminRequestsManagementTab,
  AccountsImprestExpenseRequestMangement,
  ImprestCheckerRequest,
} from "../components/ImprestManagement/ImprestExpenseRequestManagement.jsx";
import { VehicleManagement } from "../components/SiteManagement/VehicleManagement/VehicleManagementComponenets.jsx";
import { InventoryManagementComponent } from "../components/SiteManagement/InventoryManagement/InventoryManagementComponent.jsx";
import BdDashboard from "../pages/bddashboard/BdDashboard.jsx";
import AccountDashboard from "../pages/accountdashboard/AccountDashboard.jsx";
import HrDashboard from "../pages/hrdashboard/HrDashboard.jsx";
import BdProject from "../pages/bddashboard/BdProject.jsx";
import { components } from "react-select";
import AdminDashboardDetails from "../pages/admindashboard/AdminDashboardDetails.jsx";

import ImprestExpenseManagement from "../components/ImprestManagement/ImprestExpenseManagement.jsx";
import ExpenseSlipByExpense from "../components/ImprestManagement/ExpenseSheet/ExpenseSlipByExpense.jsx";
import ExpenseSlipByRequest from "../components/ImprestManagement/ExpenseSheet/ExpenseSlipByRequest.jsx";
import AuthorityManagementDashboard from "../pages/Authority/AuthorityDashboardd.jsx";
import Dataentrydashboard from "../pages/dataentryoperator/Dataentrydashboard.jsx";
import CertificationDashboard from "../pages/certificationsportal/CertificationDashboard.jsx";
import CertificationbdDashboard from "../pages/certificationbdportal/CertificationbdDashboard.jsx";
import { LetterExchangePage } from "../components/SiteManagement/ProjectDetailsCrudButtons.jsx";

import CheckerDashboard from "../pages/checkerportal/CheckerDashboard.jsx";
// import AdminBillingDetails from "../components/BillingDetails/AdminBillingDetails.jsx";
// import { AdminBillingDetails } from "../components/BillingDetails/AdminBillingDetails.jsx";
// import { AuthorityBillingDetails } from "../components/BillingDetails/AuthorityBillingDetails.jsx";
import {
  OfficeAccstage,
  RequestOfficeBillingAdmin,
  RequestOfficeBillingAuthority,
  RequestOfficeBillingChecker,
} from "../components/OfficeRent/OfficeBillingapprovemain.jsx";
import Miscellaneous from "../components/Miscellaneous/Miscellaneous.jsx";
import Settings from "../components/settings/SettingsManagement.jsx";
import PnLSheet from "../components/ProfitAndLoss/PnLManagement.jsx";

import {
  RequestVehicleBillingAdmin,
  RequestVehicleBillingAuthority,
  VehicleBillingAccManagement,
  RequestVehicleBillingChecker,
} from "../components/VehicleBillingdetails/VehicleBillingtables.jsx";
import {
  RequestInvoiceBillingChecker,
  RequestInvoiceBillingAuthority,
  RequestInvoiceBillingAdmin,
  InvoiceBillingAccManagement,
} from "../components/InvoicebIllingDetails/InvoiceBillingtable.jsx";

import {
  RequestImprestBillingChecker,
  RequestImprestBillingAuthority,
  RequestImprestBillingAdmin,
  ImprestBillingAccManagement,
} from "../components/ImprestManagement/ImprestBillingtable.jsx";

import {
  RequestExpenseBillingChecker,
  RequestExpenseBillingAuthority,
  RequestExpenseBillingAdmin,
  ExpenseBillingAccManagement,
} from "../components/ImprestManagement/ExpenseSheet/ExpenseBillingtable.jsx";

import Ticket from "../components/TicketBooking/Ticket.jsx";
import TicketsManagement, {
  MyTickets,
} from "../components/TicketsManagement/TicketsManagement.jsx";
import { ViewTask } from "../components/TaskManagement/TaskComponents.jsx";
import TasksPage from "../components/TaskManagement/TaskPage.jsx";
import { DynamicRequestsManagementTab } from "../components/settings/DynamicApprovalProcess/DynamicApprovalDisplay.jsx";
import Bid from "../components/Bid/Bid.jsx";
import BidDetails from "../components/Bid/Biddetails.jsx";
import BidList from "../components/Bid/Bidlist.jsx";
import TargetBidList from "../components/Bid/TargetBidlist.jsx";

import FinalizeBidList from "../components/Bid/FinalizeBidList.jsx";
import JvPartner from "../components/Bid/JvPartner.jsx";
import Tender from "../components/Tender/Tender.jsx";
import BidTenderManagement from "../components/Bid/BidTenderManagement.jsx";
import ProjectExpense from "../components/ProjectExpense/Projectexpense.jsx";
import AllTender from "../components/Bid/AllTender.jsx";
import SubmittedTender from "../components/Bid/SubmittedTender.jsx";
import { Cv } from "../components/Bid/Cv.jsx";
import SearchTender from "../components/Bid/SearchTender.jsx";
import AdminDasboardCIPL from "../pages/admindashboard/AdminDasboardCipl.jsx";

import CertificationAccessCvTeamDashboard from "../pages/CertificationAccessCvTeamportal/CertificationAccessCvTeamDashboard.jsx";
import CertificationAccessCvTeamHeadDashboard from "../pages/CertificationAccessCvTeamHead/CertificationAccessCvTeamHeadDashboard.jsx";
import CertificationAccessDocumentTeamDashboard from "../pages/CertificationAccessDocumentTeamportal/CertificationAccessDocumentTeamDashboard.jsx";
import CertificationAccessDocumentTeamHeadDashboard from "../pages/CertificationAccessDocumentTeamHeadportal/CertificationAccessDocumentTeamHeadDashboard.jsx";
// whatsappp messenger import

import WhatsAppChat from "../components/Bid/Whatsapp.jsx";
import ViewDashboard from "../components/viewerportal/ViewerDashboard.jsx";
import Designation from "../components/Bid/Designation.jsx";
import BdCountDashboard from "../components/Bid/BdCountDashboard.jsx";
import BdAccountDashboard from "../pages/bdaccountportal/BdAccountDashboard.jsx";
import Prebidbddashboard from "../pages/prebidbddashboard/Prebidbddashboard.jsx";
import Screeningteambddashboard from "../pages/screeningteambddashboard/Screeningteambddashboard.jsx";
export const routingData = [

  // for CSMS 
  {
    role: "",
    isProtected: false,
    defaultRoute: "/",
    routes: [
      {
        path: "",
        component: <Login />,
      },
      {
        path: "login",
        component: <Login />,
      },
      {
        path: "forgotpassword/",
        component: <Forgotpassword />,
      },
      {
        path: "resetpassword/:uidb64/:token/",
        component: <Resetpassword />,
      },
      {
        path: "Dashboardnavbar",
        component: <Dashboardnavbar />,
      },
      {
        path: "processComplete/",
        component: <CompletePage />,
      },
      {
        path: "Invoiceformate/:id/:sub_company/",
        component: <Invoiceformate />,
      },
      {
        path: "Vechiclelogbook/",
        component: <VehicleLogBook />,
      },
      {
        path: "Vechiclelogbook/:id/",
        component: <VehicleLogBook />,
      },
      {
        path: "LetterExchange/:letter_id/:assigned_to/",
        component: <LetterExchangePage />,
      },
      // {
      //   path: "ConsultantInvoiceTable",
      //   component: <ConsultantInvoiceTable />,
      // },
      // {
      //   path: "ConsultancyInvoice",
      //   component: <ConsultancyInvoice />,
      // },
      {
        path: "ConsultancyInvoice/:p_id/:invoice_id/",
        component: <ConsultancyInvoice />,
      },
      {
        path: "attendanceupload",
        component: <BulkAttendanceUpload />,
      },
      {
        path: "ticketSystem",
        component: <TicketsManagement />,
      },
      {
        path: "ticket/:id/",
        component: <ViewTicket />,
      },
    ],
  },
  {
    role: "",
    isProtected: false,
    defaultRoute: "jd/jdmain",
    nestedRoutes: [
      {
        routes: [
          {
            path: "userdetails",
            component: <Userdetailsmain />,
          },
          {
            path: "personalDetailss/:email/",
            component: <PersonaldetailsProfile />,
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
      },
    ],
  },
  {
    role: "SiteManagement",
    isProtected: true,
    defaultRoute: "site/projectdetails",
    nestedRoutes: [
      {
        routes: [
          {
            path: "imprestExpenseManagement",
            component: <ImprestExpenseManagement />,
          },
          {
            path: "userdetail",
            component: <UserDetails />,
          },
          {
            path: "siteManagement",
            component: <SiteManagement />,
          },
          {
            path: "wfm",
            component: <Wfm />,
          },
          {
            path: "Siteemployeedetail/:emp_code/",
            component: <SIteUserDetails />,
          },
          {
            path: "projectdetails",
            // component: <ProjectDetails />
            component: <ProjectAllDetails />,
          },
          {
            path: "letterTracking",
            component: <LetterTracking />,
          },
          {
            path: "vehiclemanagement",
            component: <VehicleManagement />,
          },
          {
            path: "circular",
            component: <SiteManagement />,
          },
          {
            path: "expenseTracking",
            component: <Expenses />,
          },
          {
            path: "inventorymanagement",
            component: <InventoryManagementComponent />,
          },
          // {
          //   path: "inventorymanagement",
          //   component: <InventoryManagementComponent />
          // },
          {
            path: "Invoiceformate/:id/:sub_company/",
            component: <Invoiceformate />,
          },
          {
            path: "Vechiclelogbook/:id/",
            component: <VehicleLogBook />,
          },

          {
            path: "expenseSlip",
            component: <ExpenseSlipByExpense />,
          },
          {
            path: "boqInvoice",
            component: <Boqinvoices />,
          },

          {
            path: "BOQ",
            component: <Invoiceformate />,
          },

          {
            path: "ConsultancyInvoice/:p_id/:invoice_id/",
            component: <ConsultancyInvoice />,
          },
          {
            path: "ConsultancyInvoiceDeductions/:p_id/:invoice_id/",
            component: <ConsultancyDeduction />,
          },
          {
            path: "requestExpenseSlip/:id/",
            component: <ExpenseSlipByRequest />,
          },
          {
            path: "officerent",
            component: <OfficeManagement />,
          },

          {
            path: "PrintInvoice/:p_id/:invoice_id/",
            component: <PrintPayment />,
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
        path: "site",
        component: <SiteManagementDashboard />,
      },
    ],
  },

  {
    role: "Admin",
    isProtected: true,
    // defaultRoute: "admin/adminDashboard",
    defaultRoute: "admin/siteprojects",
    nestedRoutes: [
      {
        routes: [
          {
            path: "dashboard",
            component: <AdminDashboardDetails />,
          },
          {
            path: "userdetail",
            component: <UserDetails />,
          },
          {
            path: "circular",
            component: <SiteManagement />,
          },
          {
            path: "wfm",
            component: <Wfm />,
          },
          {
            path: "letterTracking",
            component: <LetterTracking />,
          },
          {
            path: "vehiclemanagement",
            component: <VehicleManagement />,
          },
          {
            path: "payrollmanagement",
            component: <ManagePayroll />,
          },

          {
            path: "imprestExpenseManagement",
            component: <ImprestExpenseManagement />,
          },
          {
            path: "inventorymanagement",
            component: <InventoryManagementComponent />,
          },
          {
            path: "ProjectAllDetails",
            component: <ProjectAllDetails />,
          },

          {
            path: "SiteProjectBillDetails",
            component: <SiteProjectBillDetails />,
          },
          {
            path: "personalDetailss/:email/",
            component: <PersonaldetailsProfile />,
          },
          {
            path: "siteprojects",
            component: <SiteProjectTable />,
          },
          {
            path: "detailspage",
            component: <Detailspage />,
          },
          {
            path: "Invoiceformate/:id/:sub_company/",
            component: <Invoiceformate />,
          },
          {
            path: "boqInvoice",
            component: <Boqinvoices />,
          },
          {
            path: "ConsultancyInvoice",
            component: <ConsultancyInvoice />,
          },
          {
            path: "ConsultancyInvoice/:p_id/:invoice_id/",
            component: <ConsultancyInvoice />,
          },
          {
            path: "ConsultancyInvoiceDeductions/:p_id/:invoice_id/",
            component: <ConsultancyDeduction />,
          },
          {
            path: "PrintInvoice/:p_id/:invoice_id/",
            component: <PrintPayment />,
          },
          {
            path: "Vechiclelogbook/:id/",
            component: <VehicleLogBook />,
          },
          {
            path: "Siteemployeedetail/:emp_code/",
            component: <SIteUserDetails />,
          },

          {
            path: "requestManagement",
            component: <DynamicRequestsManagementTab />,
          },
          {
            path: "teamRequestManagement",
            component: <HORequestsManagementTab />,
          },
          {
            path: "adminRequestManagement",
            component: <AdminRequestsManagementTab />,
          },
          {
            path: "imprestandexpenserequest",
            component: <ImprestRequest />,
          },
          {
            path: "expenseSlip",
            component: <ExpenseSlipByExpense />,
          },
          {
            path: "requestExpenseSlip/:id/",
            component: <ExpenseSlipByRequest />,
          },
          {
            path: "certification",
            component: <CertficateAccess />,
          },

          {
            path: "officerent",
            component: <OfficeManagement />,
          },
          {
            path: "officeBillingrequest",
            component: <RequestOfficeBillingAdmin />,
          },

          {
            path: "vehicleBillingrequest",
            component: <RequestVehicleBillingAdmin />,
          },
          {
            path: "invoiceBillingRequest",
            component: <RequestInvoiceBillingAdmin />,
          },
          {
            path: "imprestBillingrequest",
            component: <RequestImprestBillingAdmin />,
          },
          {
            path: "expenseBillingRequest",
            component: <RequestExpenseBillingAdmin />,
          },

          {
            path: "criticalIssues",
            component: <TasksPage />,
          },
          {
            path: "setting",
            component: <Settings />,
            // component: <></>,
          },
          {
            path: "projectexpense",
            component: <ProjectExpense />,
          },
          {
            path: "criticaltasks",
            component: <Miscellaneous />,
          },

          {
            path: "PnLSheet",
            component: <PnLSheet />,
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
          {
            path: "task/:id/",
            component: <ViewTask />,
          },
          {
            path: "tenderDetails",
            component: <BidDetails />,
          },
        ],
        path: "admin",
        component: <AdminDashboardd />,
      },
    ],
  },
  {
    role: "AdminCIPL",
    isProtected: true,
    // defaultRoute: "admin/adminDashboard",
    defaultRoute: "admincipl/siteprojects",
    nestedRoutes: [
      {
        routes: [
          // {
          //   path: "dashboard",
          //   component: <AdminDashboardDetails />,
          // },
          {
            path: "userdetail",
            component: <UserDetails />,
          },
          {
            path: "circular",
            component: <SiteManagement />,
          },
          {
            path: "wfm",
            component: <Wfm />,
          },
          {
            path: "letterTracking",
            component: <LetterTracking />,
          },
          {
            path: "vehiclemanagement",
            component: <VehicleManagement />,
          },
          {
            path: "payrollmanagement",
            component: <ManagePayroll />,
          },

          {
            path: "imprestExpenseManagement",
            component: <ImprestExpenseManagement />,
          },
          {
            path: "inventorymanagement",
            component: <InventoryManagementComponent />,
          },
          {
            path: "ProjectAllDetails",
            component: <ProjectAllDetails />,
          },

          {
            path: "SiteProjectBillDetails",
            component: <SiteProjectBillDetails />,
          },
          {
            path: "personalDetailss/:email/",
            component: <PersonaldetailsProfile />,
          },
          {
            path: "siteprojects",
            component: <SiteProjectTable />,
          },
          {
            path: "detailspage",
            component: <Detailspage />,
          },
          {
            path: "Invoiceformate/:id/:sub_company/",
            component: <Invoiceformate />,
          },
          {
            path: "boqInvoice",
            component: <Boqinvoices />,
          },
          {
            path: "ConsultancyInvoice",
            component: <ConsultancyInvoice />,
          },
          {
            path: "ConsultancyInvoice/:p_id/:invoice_id/",
            component: <ConsultancyInvoice />,
          },
          {
            path: "ConsultancyInvoiceDeductions/:p_id/:invoice_id/",
            component: <ConsultancyDeduction />,
          },
          {
            path: "PrintInvoice/:p_id/:invoice_id/",
            component: <PrintPayment />,
          },
          {
            path: "Vechiclelogbook/:id/",
            component: <VehicleLogBook />,
          },
          {
            path: "Siteemployeedetail/:emp_code/",
            component: <SIteUserDetails />,
          },

          {
            path: "requestManagement",
            component: <DynamicRequestsManagementTab />,
          },
          {
            path: "teamRequestManagement",
            component: <HORequestsManagementTab />,
          },
          {
            path: "adminRequestManagement",
            component: <AdminRequestsManagementTab />,
          },
          {
            path: "imprestandexpenserequest",
            component: <ImprestRequest />,
          },
          {
            path: "expenseSlip",
            component: <ExpenseSlipByExpense />,
          },
          {
            path: "requestExpenseSlip/:id/",
            component: <ExpenseSlipByRequest />,
          },
          {
            path: "certification",
            component: <CertficateAccess />,
          },

          {
            path: "officerent",
            component: <OfficeManagement />,
          },
          {
            path: "officeBillingrequest",
            component: <RequestOfficeBillingAdmin />,
          },

          {
            path: "vehicleBillingrequest",
            component: <RequestVehicleBillingAdmin />,
          },
          {
            path: "invoiceBillingRequest",
            component: <RequestInvoiceBillingAdmin />,
          },
          {
            path: "imprestBillingrequest",
            component: <RequestImprestBillingAdmin />,
          },
          {
            path: "expenseBillingRequest",
            component: <RequestExpenseBillingAdmin />,
          },

          {
            path: "criticalIssues",
            component: <TasksPage />,
          },
          {
            path: "setting",
            component: <Settings />,
            // component: <></>,
          },
          {
            path: "projectexpense",
            component: <ProjectExpense />,
          },
          {
            path: "criticaltasks",
            component: <Miscellaneous />,
          },

          {
            path: "PnLSheet",
            component: <PnLSheet />,
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
          {
            path: "task/:id/",
            component: <ViewTask />,
          },
        ],
        path: "admincipl",
        component: <AdminDasboardCIPL />,
      },
    ],
  },

  {
    role: "SuperAdmin",
    isProtected: true,
    // defaultRoute: "super/superadminDashboard",
    defaultRoute: "super/siteprojects",
    nestedRoutes: [
      {
        routes: [
          // {
          //   path: "dashboard",
          //   component: <AdminDashboardDetails />,
          // },
          {
            path: "userdetail",
            component: <UserDetails />,
          },
          {
            path: "circular",
            component: <SiteManagement />,
          },
          {
            path: "wfm",
            component: <Wfm />,
          },
          {
            path: "letterTracking",
            component: <LetterTracking />,
          },
          {
            path: "vehiclemanagement",
            component: <VehicleManagement />,
          },
          {
            path: "payrollmanagement",
            component: <ManagePayroll />,
          },

          {
            path: "imprestExpenseManagement",
            component: <ImprestExpenseManagement />,
          },
          {
            path: "inventorymanagement",
            component: <InventoryManagementComponent />,
          },
          {
            path: "ProjectAllDetails",
            component: <ProjectAllDetails />,
          },

          {
            path: "SiteProjectBillDetails",
            component: <SiteProjectBillDetails />,
          },
          {
            path: "personalDetailss/:email/",
            component: <PersonaldetailsProfile />,
          },
          {
            path: "siteprojects",
            component: <SiteProjectTable />,
          },
          {
            path: "Invoiceformate/:id/:sub_company/",
            component: <Invoiceformate />,
          },
          {
            path: "boqInvoice",
            component: <Boqinvoices />,
          },
          {
            path: "ConsultancyInvoice",
            component: <ConsultancyInvoice />,
          },
          {
            path: "ConsultancyInvoice/:p_id/:invoice_id/",
            component: <ConsultancyInvoice />,
          },
          {
            path: "ConsultancyInvoiceDeductions/:p_id/:invoice_id/",
            component: <ConsultancyDeduction />,
          },
          {
            path: "Vechiclelogbook/:id/",
            component: <VehicleLogBook />,
          },
          {
            path: "Siteemployeedetail/:emp_code/",
            component: <SIteUserDetails />,
          },
          {
            path: "requestManagement",
            component: <DynamicRequestsManagementTab />,
          },
          {
            path: "teamRequestManagement",
            component: <HORequestsManagementTab />,
          },
          {
            path: "adminRequestManagement",
            component: <AdminRequestsManagementTab />,
          },
          {
            path: "imprestandexpenserequest",
            component: <ImprestRequest />,
          },
          {
            path: "expenseSlip",
            component: <ExpenseSlipByExpense />,
          },
          {
            path: "requestExpenseSlip/:id/",
            component: <ExpenseSlipByRequest />,
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
        path: "superadmin",
        component: <AdminDashboardd />,
      },
    ],
  },

  {
    role: "HOsManagement",
    isProtected: true,
    defaultRoute: "hos/userdetail",
    nestedRoutes: [
      {
        routes: [
          {
            path: "userdetail",
            component: <UserDetails />,
          },
          {
            path: "siteManagement",
            component: <SiteManagement />,
          },

          {
            path: "inventorymanagement",
            component: <InventoryManagementComponent />,
          },

          {
            path: "vehiclemanagement",
            component: <VehicleManagement />,
          },
          {
            path: "Invoiceformate/:id/:sub_company/",
            component: <Invoiceformate />,
          },
          {
            path: "requestManagement",
            component: <DynamicRequestsManagementTab />,
          },
          {
            path: "teamRequestManagement",
            component: <HORequestsManagementTab />,
          },
          {
            path: "expenseSlip",
            component: <ExpenseSlipByExpense />,
          },
          {
            path: "requestExpenseSlip/:id/",
            component: <ExpenseSlipByRequest />,
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
        path: "hos",
        component: <HOSupervisorManagementDashboard />,
      },
    ],
  },

  {
    role: "Hr",
    isProtected: true,
    defaultRoute: "hr/",
    nestedRoutes: [
      {
        routes: [
          // {
          //   path: "dashboard",
          //   component: <AdminDashboardDetails />,
          // },
          {
            path: "userdetail",
            component: <UserDetails />,
          },
          {
            path: "circular",
            component: <SiteManagement />,
          },
          {
            path: "wfm",
            component: <Wfm />,
          },
          {
            path: "letterTracking",
            component: <LetterTracking />,
          },
          {
            path: "vehiclemanagement",
            component: <VehicleManagement />,
          },
          {
            path: "payrollmanagement",
            component: <ManagePayroll />,
          },

          {
            path: "imprestExpenseManagement",
            component: <ImprestExpenseManagement />,
          },
          {
            path: "inventorymanagement",
            component: <InventoryManagementComponent />,
          },
          {
            path: "ProjectAllDetails",
            component: <ProjectAllDetails />,
          },

          {
            path: "SiteProjectBillDetails",
            component: <SiteProjectBillDetails />,
          },
          {
            path: "personalDetailss/:email/",
            component: <PersonaldetailsProfile />,
          },
          {
            path: "siteprojects",
            component: <SiteProjectTable />,
          },
          {
            path: "Invoiceformate/:id/:sub_company/",
            component: <Invoiceformate />,
          },
          {
            path: "boqInvoice",
            component: <Boqinvoices />,
          },
          {
            path: "ConsultancyInvoice",
            component: <ConsultancyInvoice />,
          },
          {
            path: "ConsultancyInvoice/:p_id/:invoice_id/",
            component: <ConsultancyInvoice />,
          },
          {
            path: "ConsultancyInvoiceDeductions/:p_id/:invoice_id/",
            component: <ConsultancyDeduction />,
          },
          {
            path: "Vechiclelogbook/:id/",
            component: <VehicleLogBook />,
          },
          {
            path: "Siteemployeedetail/:emp_code/",
            component: <SIteUserDetails />,
          },
          {
            path: "requestManagement",
            component: <DynamicRequestsManagementTab />,
          },
          {
            path: "teamRequestManagement",
            component: <HORequestsManagementTab />,
          },
          {
            path: "adminRequestManagement",
            component: <AdminRequestsManagementTab />,
          },
          {
            path: "imprestandexpenserequest",
            component: <ImprestRequest />,
          },
          {
            path: "expenseSlip",
            component: <ExpenseSlipByExpense />,
          },
          {
            path: "requestExpenseSlip/:id/",
            component: <ExpenseSlipByRequest />,
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
        path: "hr",
        component: <HrDashboard />,
      },
    ],
  },
  {
    role: "BD",
    isProtected: true,
    defaultRoute: "bd/searchTender",
    nestedRoutes: [
      {
        routes: [
          {
            path: "certification",
            component: <CertficateAccess />,
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "tender",
            component: <BidTenderManagement />,
          },
          {
            path: "whatsapp",
            component: <WhatsAppChat />,
          },
          {
            path: "tenderDetails",
            component: <BidDetails />,
          },
          {
            path: "bidList",
            component: <BidList />,
          },
          {
            path: "targetBidList",
            component: <TargetBidList />,
          },
          {
            path: "finalBidList",
            component: <FinalizeBidList />,
          },
          {
            path: "partnermanagement",
            component: <JvPartner />,
          },
          {
            path: "allTender",
            component: <AllTender />,
          },
          {
            path: "searchTender",
            component: <SearchTender />,
          },
          {
            path: "cv",
            component: <Cv />,
          },
          {
            path: "designation",
            component: <Designation />,
          },
          {
            path: "bg",
            component: <SubmittedTender />,
          },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
        path: "bd",
        component: <BdDashboard />,
      },
    ],
  },
  {
    role: "Account",
    isProtected: true,
    // defaultRoute: "account/",
    defaultRoute: "account/",
    nestedRoutes: [
      {
        routes: [
          // {
          //   path: "dashboard",
          //   component: <AdminDashboardDetails />,
          // },
          {
            path: "userdetail",
            component: <UserDetails />,
          },
          {
            path: "circular",
            component: <SiteManagement />,
          },
          {
            path: "wfm",
            component: <Wfm />,
          },
          {
            path: "letterTracking",
            component: <LetterTracking />,
          },
          {
            path: "vehiclemanagement",
            component: <VehicleManagement />,
          },
          {
            path: "payrollmanagement",
            component: <ManagePayroll />,
          },

          {
            path: "imprestExpenseManagement",
            component: <ImprestExpenseManagement />,
          },
          {
            path: "inventorymanagement",
            component: <InventoryManagementComponent />,
          },
          {
            path: "ProjectAllDetails",
            component: <ProjectAllDetails />,
          },

          {
            path: "SiteProjectBillDetails",
            component: <SiteProjectBillDetails />,
          },
          {
            path: "personalDetailss/:email/",
            component: <PersonaldetailsProfile />,
          },
          {
            path: "siteprojects",
            component: <SiteProjectTable />,
          },
          {
            path: "Invoiceformate/:id/:sub_company/",
            component: <Invoiceformate />,
          },
          {
            path: "boqInvoice",
            component: <Boqinvoices />,
          },
          {
            path: "ConsultancyInvoice",
            component: <ConsultancyInvoice />,
          },
          {
            path: "ConsultancyInvoice/:p_id/:invoice_id/",
            component: <ConsultancyInvoice />,
          },
          {
            path: "ConsultancyInvoiceDeductions/:p_id/:invoice_id/",
            component: <ConsultancyDeduction />,
          },
          {
            path: "Vechiclelogbook/:id/",
            component: <VehicleLogBook />,
          },
          {
            path: "Siteemployeedetail/:emp_code/",
            component: <SIteUserDetails />,
          },
          {
            path: "projectexpense",
            component: <ProjectExpense />,
          },
          {
            path: "requestManagement",
            component: <DynamicRequestsManagementTab />,
          },
          {
            path: "teamRequestManagement",
            component: <HORequestsManagementTab />,
          },
          {
            path: "adminRequestManagement",
            component: <AdminRequestsManagementTab />,
          },
          {
            path: "accountRequestManagement",
            component: <AccountsImprestExpenseRequestMangement />,
          },
          {
            path: "imprestandexpenserequest",
            component: <ImprestRequest />,
          },
          {
            path: "expenseSlip",
            component: <ExpenseSlipByExpense />,
          },
          {
            path: "requestExpenseSlip/:id/",
            component: <ExpenseSlipByRequest />,
          },
          {
            path: "officeBillingrequest",
            component: <OfficeAccstage />,
          },
          {
            path: "vehicleBillingrequest",
            component: <VehicleBillingAccManagement />,
          },
          {
            path: "invoiceBillingRequest",
            component: <InvoiceBillingAccManagement />,
          },
          {
            path: "imprestBillingrequest",
            component: <ImprestBillingAccManagement />,
          },

          {
            path: "expenseBillingRequest",
            component: <ExpenseBillingAccManagement />,
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
          {
            path: "requestManagement",
            component: <DynamicRequestsManagementTab />,
          },
        ],
        path: "account",
        component: <AccountDashboard />,
      },
    ],
  },

  {
    role: "AuthorityEngineer",
    isProtected: true,
    defaultRoute: "authority/siteprojects",
    nestedRoutes: [
      {
        routes: [
          // {
          //   path: "dashboard",
          //   component: <AdminDashboardDetails />,
          // },
          {
            path: "userdetail",
            component: <UserDetails />,
          },
          {
            path: "circular",
            component: <SiteManagement />,
          },
          {
            path: "wfm",
            component: <Wfm />,
          },
          {
            path: "letterTracking",
            component: <LetterTracking />,
          },
          {
            path: "vehiclemanagement",
            component: <VehicleManagement />,
          },
          {
            path: "payrollmanagement",
            component: <ManagePayroll />,
          },

          {
            path: "imprestExpenseManagement",
            component: <ImprestExpenseManagement />,
          },
          {
            path: "inventorymanagement",
            component: <InventoryManagementComponent />,
          },
          {
            path: "ProjectAllDetails",
            component: <ProjectAllDetails />,
          },

          {
            path: "SiteProjectBillDetails",
            component: <SiteProjectBillDetails />,
          },
          {
            path: "personalDetailss/:email/",
            component: <PersonaldetailsProfile />,
          },
          {
            path: "siteprojects",
            component: <SiteProjectTable />,
          },
          {
            path: "Invoiceformate/:id/:sub_company/",
            component: <Invoiceformate />,
          },
          {
            path: "boqInvoice",
            component: <Boqinvoices />,
          },
          {
            path: "ConsultancyInvoice",
            component: <ConsultancyInvoice />,
          },
          {
            path: "ConsultancyInvoice/:p_id/:invoice_id/",
            component: <ConsultancyInvoice />,
          },
          {
            path: "ConsultancyInvoiceDeductions/:p_id/:invoice_id/",
            component: <ConsultancyDeduction />,
          },
          {
            path: "Vechiclelogbook/:id/",
            component: <VehicleLogBook />,
          },
          {
            path: "Siteemployeedetail/:emp_code/",
            component: <SIteUserDetails />,
          },
          {
            path: "requestManagement",
            component: <DynamicRequestsManagementTab />,
          },
          {
            path: "requestManagement",
            component: <DynamicRequestsManagementTab />,
          },
          {
            path: "teamRequestManagement",
            component: <HORequestsManagementTab />,
          },
          {
            path: "adminRequestManagement",
            component: <AdminRequestsManagementTab />,
          },
          {
            path: "imprestandexpenserequest",
            component: <ImprestRequest />,
          },
          {
            path: "expenseSlip",
            component: <ExpenseSlipByExpense />,
          },
          {
            path: "requestExpenseSlip/:id/",
            component: <ExpenseSlipByRequest />,
          },
          {
            path: "officeBillingrequest",
            component: <RequestOfficeBillingAuthority />,
          },
          {
            path: "vehicleBillingrequest",
            component: <RequestVehicleBillingAuthority />,
          },

          {
            path: "invoiceBillingrequest",
            component: <RequestInvoiceBillingAuthority />,
          },
          {
            path: "imprestBillingrequest",
            component: <RequestImprestBillingAuthority />,
          },
          {
            path: "expenseBillingRequest",
            component: <RequestExpenseBillingAuthority />,
          },
          {
            path: "invoiceBillingRequest",
            component: <RequestInvoiceBillingAuthority />,
          },
          // {
          //   path: "projectexpense",
          //   component: <ProjectExpense />,
          // },

          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
        path: "authority",
        component: <AuthorityManagementDashboard />,
      },
    ],
  },

  {
    role: "CertificationAccess",
    isProtected: true,
    defaultRoute: "certificaionadminaccess/searchTender",
    nestedRoutes: [
      {
        routes: [
          {
            path: "BdDashboard",
            component: <BdCountDashboard />,
          },
          {
            path: "certification",
            component: <CertficateAccess />,
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "tender",
            component: <BidTenderManagement />,
          },
          {
            path: "messenger",
            component: <WhatsAppChat />,
          },
          {
            path: "tenderDetails",
            component: <BidDetails />,
          },
          {
            path: "bidList",
            component: <BidList />,
          },
          {
            path: "targetBidList",
            component: <TargetBidList />,
          },
          {
            path: "finalBidList",
            component: <FinalizeBidList />,
          },
          {
            path: "partnermanagement",
            component: <JvPartner />,
          },
          {
            path: "allTender",
            component: <AllTender />,
          },
          {
            path: "searchTender",
            component: <SearchTender />,
          },
          {
            path: "cv",
            component: <Cv />,
          },
          {
            path: "designation",
            component: <Designation />,
          },
          {
            path: "bg",
            component: <SubmittedTender />,
          },
          // {
          //   path: "tender",
          //   component: <Tender />,
          // },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
        path: "certificaionadminaccess",
        component: <CertificationDashboard />,
      },
    ],
  },
  {
    role: "BdDashbaordAccount",
    isProtected: true,
    defaultRoute: "bddashbaordaccount/bg",
    nestedRoutes: [
      {
        routes: [
          {
            path: "bg",
            component: <SubmittedTender />,
          },

          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
        path: "bddashbaordaccount",
        component: <BdAccountDashboard />,
      },
    ],
  },
  {
    role: "BdDashboardPrebid",
    isProtected: true,
    defaultRoute: "bddashboardprebid/tender",
    nestedRoutes: [
      {
        routes: [
          {
            path: "tender",
            component: <Bid />,
          },

          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
        path: "bddashboardprebid",
        component: <BdAccountDashboard />,
      },
    ],
  },
  {
    role: "ScreeningTeam",
    isProtected: true,
    defaultRoute: "screeningteam/tender",
    nestedRoutes: [
      {
        routes: [
          {
            path: "searchTender",
            component: <SearchTender />,
          },
          {
            path: "tender",
            component: <Bid />,
          },

          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
        path: "screeningteam",
        component: <Screeningteambddashboard />,
      },
    ],
  },
  {
    role: "CertificationAccessBd",
    isProtected: true,
    defaultRoute: "certificaionbdaccess/searchTender",
    nestedRoutes: [
      {
        routes: [
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "tender",
            component: <BidTenderManagement />,
          },
          {
            path: "messenger",
            component: <WhatsAppChat />,
          },
          {
            path: "tenderDetails",
            component: <BidDetails />,
          },

          {
            path: "searchTender",
            component: <SearchTender />,
          },

          // {
          //   path: "tender",
          //   component: <Tender />,
          // },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
        path: "certificaionbdaccess",
        component: <CertificationbdDashboard />,
      },
    ],
  },
  {
    role: "CertificationAccessDocumentTeamHead",
    isProtected: true,
    defaultRoute: "CertificationAccessDocumentTeamHead/searchTender",
    nestedRoutes: [
      {
        routes: [
          {
            path: "tenderDetails",
            component: <BidDetails />,
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "tender",
            component: <BidTenderManagement />,
          },
          {
            path: "messenger",
            component: <WhatsAppChat />,
          },
          {
            path: "searchTender",
            component: <SearchTender />,
          },

          // {
          //   path: "tender",
          //   component: <Tender />,
          // },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
        path: "CertificationAccessDocumentTeamHead",
        component: <CertificationAccessDocumentTeamHeadDashboard />,
      },
    ],
  },
  {
    role: "CertificationAccessDocumentTeam",
    isProtected: true,
    defaultRoute: "CertificationAccessDocumentTeam/searchTender",
    nestedRoutes: [
      {
        routes: [
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "tender",
            component: <BidTenderManagement />,
          },
          {
            path: "messenger",
            component: <WhatsAppChat />,
          },
          {
            path: "tenderDetails",
            component: <BidDetails />,
          },

          {
            path: "searchTender",
            component: <SearchTender />,
          },

          // {
          //   path: "tender",
          //   component: <Tender />,
          // },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
        path: "CertificationAccessDocumentTeam",
        component: <CertificationAccessDocumentTeamDashboard />,
      },
    ],
  },
  {
    role: "CertificationAccessCvTeam",
    isProtected: true,
    defaultRoute: "CertificationAccessCvTeam/searchTender",
    nestedRoutes: [
      {
        routes: [
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "tender",
            component: <BidTenderManagement />,
          },
          {
            path: "messenger",
            component: <WhatsAppChat />,
          },
          {
            path: "tenderDetails",
            component: <BidDetails />,
          },

          {
            path: "searchTender",
            component: <SearchTender />,
          },

          {
            path: "designation",
            component: <Designation />,
          },
          // {
          //   path: "tender",
          //   component: <Tender />,
          // },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
        path: "CertificationAccessCvTeam",
        component: <CertificationAccessCvTeamDashboard />,
      },
    ],
  },
  {
    role: "CertificationAccessCvTeamHead",
    isProtected: true,
    defaultRoute: "CertificationAccessCvTeamHead/searchTender",
    nestedRoutes: [
      {
        routes: [
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "tender",
            component: <BidTenderManagement />,
          },
          {
            path: "messenger",
            component: <WhatsAppChat />,
          },
          {
            path: "tenderDetails",
            component: <BidDetails />,
          },

          {
            path: "designation",
            component: <Designation />,
          },

          {
            path: "searchTender",
            component: <SearchTender />,
          },

          // {
          //   path: "tender",
          //   component: <Tender />,
          // },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
        path: "CertificationAccessCvTeamHead",
        component: <CertificationAccessCvTeamHeadDashboard />,
      },
    ],
  },
  {
    role: "Employee",
    isProtected: true,
    defaultRoute: "emp/siteprojects",
    nestedRoutes: [
      {
        routes: [
          {
            path: "siteprojects",
            component: <SiteProjectTable />,
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
        path: "emp",
        component: <EmployeeDashboard />,
      },
    ],
  },
  {
    role: "Checker",
    isProtected: true,
    defaultRoute: "checker/requestManagement",
    nestedRoutes: [
      {
        routes: [
          {
            path: "siteprojects",
            component: <SiteProjectTable />,
          },
          {
            path: "imprestExpenseManagement",
            component: <ImprestExpenseManagement />,
          },
          {
            path: "ProjectAllDetails",
            component: <ProjectAllDetails />,
          },
          {
            path: "officeBillingrequest",
            component: <RequestOfficeBillingChecker />,
          },
          {
            path: "Vechiclelogbook/:id/",
            component: <VehicleLogBook />,
          },
          {
            path: "vehicleBillingrequest",
            component: <RequestVehicleBillingChecker />,
          },
          {
            path: "requestManagement",
            component: <DynamicRequestsManagementTab />,
          },
          {
            path: "teamRequestManagement",
            component: <HORequestsManagementTab />,
          },
          {
            path: "adminRequestManagement",
            component: <AdminRequestsManagementTab />,
          },
          {
            path: "officerent",
            component: <OfficeManagement />,
          },
          {
            path: "accountRequestManagement",
            component: <AccountsImprestExpenseRequestMangement />,
          },
          {
            path: "imprestandexpenserequest",
            component: <ImprestRequest />,
          },
          {
            path: "requestExpenseSlip/:id/",
            component: <ExpenseSlipByRequest />,
          },
          {
            path: "checkerRequestManagement",
            component: <ImprestCheckerRequest />,
          },

          {
            path: "vehiclemanagement",
            component: <VehicleManagement />,
          },
          {
            path: "expenseBillingRequest",
            component: <RequestExpenseBillingChecker />,
          },
          {
            path: "invoiceBillingRequest",
            component: <RequestInvoiceBillingChecker />,
          },
          {
            path: "boqInvoice",
            component: <Boqinvoices />,
          },
          {
            path: "Invoiceformate/:id/:sub_company/",
            component: <Invoiceformate />,
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "inventorymanagement",
            component: <InventoryManagementComponent />,
          },
          {
            path: "ConsultancyInvoice",
            component: <ConsultancyInvoice />,
          },
          {
            path: "ConsultancyInvoice/:p_id/:invoice_id/",
            component: <ConsultancyInvoice />,
          },
          {
            path: "ConsultancyInvoiceDeductions/:p_id/:invoice_id/",
            component: <ConsultancyDeduction />,
          },
          {
            path: "PrintInvoice/:p_id/:invoice_id/",
            component: <PrintPayment />,
          },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
          {
            path: "circular",
            component: <SiteManagement />,
          },
        ],
        path: "checker",
        component: <CheckerDashboard />,
      },
    ],
  },
  {
    role: "DataEntryOperator",
    isProtected: true,
    defaultRoute: "operator/siteprojects",
    nestedRoutes: [
      {
        routes: [
          // {
          //   path: "dashboard",
          //   component: <AdminDashboardDetails />,
          // },
          {
            path: "userdetail",
            component: <UserDetails />,
          },
          {
            path: "circular",
            component: <SiteManagement />,
          },
          {
            path: "wfm",
            component: <Wfm />,
          },
          {
            path: "letterTracking",
            component: <LetterTracking />,
          },
          {
            path: "vehiclemanagement",
            component: <VehicleManagement />,
          },
          {
            path: "payrollmanagement",
            component: <ManagePayroll />,
          },

          {
            path: "imprestExpenseManagement",
            component: <ImprestExpenseManagement />,
          },
          {
            path: "inventorymanagement",
            component: <InventoryManagementComponent />,
          },
          {
            path: "ProjectAllDetails",
            component: <ProjectAllDetails />,
          },

          {
            path: "SiteProjectBillDetails",
            component: <SiteProjectBillDetails />,
          },
          {
            path: "personalDetailss/:email/",
            component: <PersonaldetailsProfile />,
          },
          {
            path: "siteprojects",
            component: <SiteProjectTable />,
          },
          {
            path: "Invoiceformate/:id/:sub_company/",
            component: <Invoiceformate />,
          },
          {
            path: "boqInvoice",
            component: <Boqinvoices />,
          },
          {
            path: "ConsultancyInvoice",
            component: <ConsultancyInvoice />,
          },
          {
            path: "ConsultancyInvoice/:p_id/:invoice_id/",
            component: <ConsultancyInvoice />,
          },
          {
            path: "ConsultancyInvoiceDeductions/:p_id/:invoice_id/",
            component: <ConsultancyDeduction />,
          },

          {
            path: "Vechiclelogbook/:id/",
            component: <VehicleLogBook />,
          },
          {
            path: "Siteemployeedetail/:emp_code/",
            component: <SIteUserDetails />,
          },

          {
            path: "teamRequestManagement",
            component: <HORequestsManagementTab />,
          },
          {
            path: "requestManagement",
            component: <DynamicRequestsManagementTab />,
          },
          {
            path: "criticalIssues",
            components: <TasksPage />,
          },
          {
            path: "imprestandexpenserequest",
            component: <ImprestRequest />,
          },
          {
            path: "expenseSlip",
            component: <ExpenseSlipByExpense />,
          },
          {
            path: "requestExpenseSlip/:id/",
            component: <ExpenseSlipByRequest />,
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
        path: "operator",
        component: <Dataentrydashboard />,
      },
    ],
  },

  {
    role: "ViewAccess",
    isProtected: true,
    defaultRoute: "viewaccess/siteprojects",
    nestedRoutes: [
      {
        routes: [
          {
            path: "userdetail",
            component: <UserDetails />,
          },
          {
            path: "circular",
            component: <SiteManagement />,
          },
          {
            path: "wfm",
            component: <Wfm />,
          },
          {
            path: "letterTracking",
            component: <LetterTracking />,
          },
          {
            path: "vehiclemanagement",
            component: <VehicleManagement />,
          },
          {
            path: "payrollmanagement",
            component: <ManagePayroll />,
          },

          {
            path: "imprestExpenseManagement",
            component: <ImprestExpenseManagement />,
          },
          {
            path: "inventorymanagement",
            component: <InventoryManagementComponent />,
          },
          {
            path: "ProjectAllDetails",
            component: <ProjectAllDetails />,
          },

          {
            path: "SiteProjectBillDetails",
            component: <SiteProjectBillDetails />,
          },
          {
            path: "personalDetailss/:email/",
            component: <PersonaldetailsProfile />,
          },
          {
            path: "siteprojects",
            component: <SiteProjectTable />,
          },
          {
            path: "detailspage",
            component: <Detailspage />,
          },
          {
            path: "Invoiceformate/:id/:sub_company/",
            component: <Invoiceformate />,
          },
          {
            path: "boqInvoice",
            component: <Boqinvoices />,
          },
          {
            path: "ConsultancyInvoice",
            component: <ConsultancyInvoice />,
          },
          {
            path: "ConsultancyInvoice/:p_id/:invoice_id/",
            component: <ConsultancyInvoice />,
          },
          {
            path: "ConsultancyInvoiceDeductions/:p_id/:invoice_id/",
            component: <ConsultancyDeduction />,
          },
          {
            path: "PrintInvoice/:p_id/:invoice_id/",
            component: <PrintPayment />,
          },
          {
            path: "Vechiclelogbook/:id/",
            component: <VehicleLogBook />,
          },
          {
            path: "Siteemployeedetail/:emp_code/",
            component: <SIteUserDetails />,
          },

          {
            path: "requestManagement",
            component: <DynamicRequestsManagementTab />,
          },
          {
            path: "teamRequestManagement",
            component: <HORequestsManagementTab />,
          },
          {
            path: "adminRequestManagement",
            component: <AdminRequestsManagementTab />,
          },
          {
            path: "imprestandexpenserequest",
            component: <ImprestRequest />,
          },
          {
            path: "expenseSlip",
            component: <ExpenseSlipByExpense />,
          },
          {
            path: "requestExpenseSlip/:id/",
            component: <ExpenseSlipByRequest />,
          },
          {
            path: "certification",
            component: <CertficateAccess />,
          },

          {
            path: "officerent",
            component: <OfficeManagement />,
          },
          {
            path: "officeBillingrequest",
            component: <RequestOfficeBillingAdmin />,
          },

          {
            path: "vehicleBillingrequest",
            component: <RequestVehicleBillingAdmin />,
          },
          {
            path: "invoiceBillingRequest",
            component: <RequestInvoiceBillingAdmin />,
          },
          {
            path: "imprestBillingrequest",
            component: <RequestImprestBillingAdmin />,
          },
          {
            path: "expenseBillingRequest",
            component: <RequestExpenseBillingAdmin />,
          },

          {
            path: "criticalIssues",
            component: <TasksPage />,
          },
          {
            path: "setting",
            component: <Settings />,
            // component: <></>,
          },
          {
            path: "projectexpense",
            component: <ProjectExpense />,
          },
          {
            path: "criticaltasks",
            component: <Miscellaneous />,
          },

          {
            path: "PnLSheet",
            component: <PnLSheet />,
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
          {
            path: "task/:id/",
            component: <ViewTask />,
          },
        ],
        path: "viewaccess",
        component: <ViewDashboard />,
      },
    ],
  },

  // For CSMS 



  // For BD Dashboard and Certification Access

  {
    role: "CertificationAccess",
    isProtected: true,
    defaultRoute: "certificaionadminaccess/searchTender",
    nestedRoutes: [
      {
        routes: [
          {
            path: 'BdDashboard',
            component: <BdCountDashboard />
          },
          {
            path: "certification",
            component: <CertficateAccess />,
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "tender",
            component: <BidTenderManagement />,
          },
          {
            path: "messenger",
            component: <WhatsAppChat />,
          },
          {
            path: "tenderDetails",
            component: <BidDetails />,
          },
          {
            path: "bidList",
            component: <BidList />,
          },
          {
            path: "targetBidList",
            component: <TargetBidList />,
          },
          {
            path: "finalBidList",
            component: <FinalizeBidList />,
          },
          {
            path: "partnermanagement",
            component: <JvPartner />,
          },
          {
            path: "allTender",
            component: <AllTender />,
          },
          {
            path: "searchTender",
            component: <SearchTender />,
          },
          {
            path: "cv",
            component: <Cv />,
          },
          {
            path: 'designation',
            component: <Designation />,
          },
          {
            path: "bg",
            component: <SubmittedTender />,
          },
          // {
          //   path: "tender",
          //   component: <Tender />,
          // },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
        path: "certificaionadminaccess",
        component: <CertificationDashboard />,
      },
    ],
  },
  {
    role: "BdDashbaordAccount",
    isProtected: true,
    defaultRoute: "bddashbaordaccount/bg",
    nestedRoutes: [
      {
        routes: [

          {
            path: "bg",
            component: <SubmittedTender />,
          },

          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
        path: "bddashbaordaccount",
        component: <BdAccountDashboard />,
      },
    ],
  },
  {
    role: "BdDashboardPrebid",
    isProtected: true,
    defaultRoute: "bddashboardprebid/tender",
    nestedRoutes: [
      {
        routes: [

          {
            path: "tender",
            component: <Bid />,
          },

          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
        path: "bddashboardprebid",
        component: <BdAccountDashboard />,
      },
    ],
  },
  {
    role: "CertificationAccessBd",
    isProtected: true,
    defaultRoute: "certificaionbdaccess/searchTender",
    nestedRoutes: [
      {
        routes: [

          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "tender",
            component: <BidTenderManagement />,
          },
          {
            path: "messenger",
            component: <WhatsAppChat />,
          },
          {
            path: "tenderDetails",
            component: <BidDetails />,
          },





          {
            path: "searchTender",
            component: <SearchTender />,
          },


          // {
          //   path: "tender",
          //   component: <Tender />,
          // },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
        path: "certificaionbdaccess",
        component: <CertificationbdDashboard />,
      },
    ],
  },
  {
    role: "CertificationAccessDocumentTeamHead",
    isProtected: true,
    defaultRoute: "CertificationAccessDocumentTeamHead/searchTender",
    nestedRoutes: [
      {
        routes: [
          {
            path: "tenderDetails",
            component: <BidDetails />,
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "tender",
            component: <BidTenderManagement />,
          },
          {
            path: "messenger",
            component: <WhatsAppChat />,
          },
          {
            path: "searchTender",
            component: <SearchTender />,
          },



          // {
          //   path: "tender",
          //   component: <Tender />,
          // },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
        path: "CertificationAccessDocumentTeamHead",
        component: <CertificationAccessDocumentTeamHeadDashboard />,
      },
    ],
  },
  {
    role: "CertificationAccessDocumentTeam",
    isProtected: true,
    defaultRoute: "CertificationAccessDocumentTeam/searchTender",
    nestedRoutes: [
      {
        routes: [

          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "tender",
            component: <BidTenderManagement />,
          },
          {
            path: "messenger",
            component: <WhatsAppChat />,
          },
          {
            path: "tenderDetails",
            component: <BidDetails />,
          },





          {
            path: "searchTender",
            component: <SearchTender />,
          },


          // {
          //   path: "tender",
          //   component: <Tender />,
          // },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
        path: "CertificationAccessDocumentTeam",
        component: <CertificationAccessDocumentTeamDashboard />,
      },
    ],
  },
  {
    role: "CertificationAccessCvTeam",
    isProtected: true,
    defaultRoute: "CertificationAccessCvTeam/searchTender",
    nestedRoutes: [
      {
        routes: [

          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "tender",
            component: <BidTenderManagement />,
          },
          {
            path: "messenger",
            component: <WhatsAppChat />,
          },
          {
            path: "tenderDetails",
            component: <BidDetails />,
          },





          {
            path: "searchTender",
            component: <SearchTender />,
          },

          {
            path: 'designation',
            component: <Designation />,
          },
          // {
          //   path: "tender",
          //   component: <Tender />,
          // },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
        path: "CertificationAccessCvTeam",
        component: <CertificationAccessCvTeamDashboard />,
      },
    ],
  },
  {
    role: "CertificationAccessCvTeamHead",
    isProtected: true,
    defaultRoute: "CertificationAccessCvTeamHead/searchTender",
    nestedRoutes: [
      {
        routes: [

          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "tender",
            component: <BidTenderManagement />,
          },
          {
            path: "messenger",
            component: <WhatsAppChat />,
          },
          {
            path: "tenderDetails",
            component: <BidDetails />,
          },


          {
            path: 'designation',
            component: <Designation />,
          },


          {
            path: "searchTender",
            component: <SearchTender />,
          },


          // {
          //   path: "tender",
          //   component: <Tender />,
          // },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
        path: "CertificationAccessCvTeamHead",
        component: <CertificationAccessCvTeamHeadDashboard />,
      },
    ],
  },
   {
    role: "BD",
    isProtected: true,
    defaultRoute: "bd/searchTender",
    nestedRoutes: [
      {
        routes: [
          {
            path: "certification",
            component: <CertficateAccess />,
          },
          {
            path: "ticketSystem",
            component: <TicketsManagement />,
          },
          {
            path: "tender",
            component: <BidTenderManagement />,
          },
          {
            path: "whatsapp",
            component: <WhatsAppChat />,
          },
          {
            path: "tenderDetails",
            component: <BidDetails />,
          },
          {
            path: "bidList",
            component: <BidList />,
          },
          {
            path: "targetBidList",
            component: <TargetBidList />,
          },
          {
            path: "finalBidList",
            component: <FinalizeBidList />,
          },
          {
            path: "partnermanagement",
            component: <JvPartner />,
          },
          {
            path: "allTender",
            component: <AllTender />,
          },
          {
            path: "searchTender",
            component: <SearchTender />,
          },
          {
            path: "cv",
            component: <Cv />,
          },
          {
            path: 'designation',
            component: <Designation />,
          },
          {
            path: "bg",
            component: <SubmittedTender />,
          },
          {
            path: "ticket/:id/",
            component: <ViewTicket />,
          },
        ],
        path: "bd",
        component: <BdDashboard />,
      },
    ],
  },
  // For BD Dashboard and Certification Access
 
];
